// import { getProjects } from "@/api";
import { apiClient } from "@/api";
import { Project, Task } from "@/api/types";
import React, { useEffect, useState } from "react";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { useNavigate, useParams } from "react-router";
import { useAuth } from "@/contexts/AuthContext";
import { ProjectTile } from "@/components/projects/ProjectTile";
import SimplePage from "@/components/structure/SimplePage";
import AppButton from "@/components/structure/AppButton";
import { faList } from "@fortawesome/free-solid-svg-icons";
import ProjectsByRole from "@/components/projects/ProjectsByRole";
import toast from "@/utils/toast";

export default function Projects() {
  const { isAuthenticated, user } = useAuth();

  return (
    <ProtectedRoute>
      <SimplePage title="Projects">
        <ProjectsByRole />

        <div className="mt-6">
          {isAuthenticated && user?.isProjectsAdmin && (
            <AppButton
              variant="primary"
              href={"/projects/new"}
            >
              Create New Project
            </AppButton>
          )}
        </div>
      </SimplePage>
    </ProtectedRoute>
  );
}
